module.exports = __webpack_public_path__ + "img/217.42f04019.jpg";